import { FC, PropsWithChildren } from 'react'
import cn from 'classnames'

type TProps = {
  className?: string
  contentClassName?: string
} & PropsWithChildren

const ResponsiveBlock: FC<TProps> = ({ className, contentClassName, children }) => {
  return (
    <div className={cn('flex w-full justify-center px-4', className)}>
      <section className={cn('flex w-full', contentClassName)} style={{ maxWidth: '1520px' }}>
        {children}
      </section>
    </div>
  )
}

export { ResponsiveBlock }
